/**
 * Main App
 */
import React from "react";
import { Provider } from "react-redux";
import { Redirect, Route, Switch, BrowserRouter } from "react-router-dom";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
// css
import "./lib/mainCss";
import "react-table/react-table.css";
// To Add Video Support you must use following CSS
// import "video.js/dist/video-js.css";

// app component
import App from "./container/App";

import { configureStore } from "./store";

const MainApp = () => (
  <Provider store={configureStore()}>
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <BrowserRouter>
        <Switch>
          <Redirect exact from={"/app"} to={"/"} />
          <Route path="/" component={App} />
        </Switch>
      </BrowserRouter>
    </MuiPickersUtilsProvider>
  </Provider>
);

export default MainApp;
